import { Injectable } from '@visiba/instantiation';

export interface DialogOptions {
	header: string;
	description: string;
	abortText: string;
}

export interface DialogOptionsWithResolver extends DialogOptions {
	resolve: () => void;
}

@Injectable()
export class DialogAlertService {
	private listeners: ((dialog: DialogOptionsWithResolver) => void)[] = [];

	public async show(dialogAlertProps: DialogOptions): Promise<void> {
		return new Promise<void>((resolve) => {
			const dialogWithResolver: DialogOptionsWithResolver = {
				...dialogAlertProps,
				resolve,
			};
			this.listeners.forEach((listener) => {
				try {
					listener(dialogWithResolver);
				} catch (error) {
					console.error('Dialog listener error:', error);
				}
			});
		});
	}

	public subscribe(listener: (dialog: DialogOptionsWithResolver) => void): () => void {
		this.listeners.push(listener);

		return () => {
			const index = this.listeners.indexOf(listener);
			if (index > -1) {
				this.listeners.splice(index, 1);
			}
		};
	}
}
